import React from 'react'
import Find from '../share/components/Find/Find'
import CarouselSevices, { servicesTravel } from '../share/components/CarouselServices/CarouselSevices'
import BannerSpecialist from './BannerSpecialist/BannerSpecialist'
import ButtonsFilters from './ButtonsFilters/ButtonsFilters'
import UseSpecialist from '../../viewModels/specialist/UseSpecialist'
import AllCardsSpecialist from './AllCardsSpecialist/AllCardsSpecialist'
import Paginado from './Paginado/Paginado'

const Specialists = () => {

  const {
    dataAlways,
    loading,
    nextHandler,
    prevHandler,
    currentPage,
    services,
    mostrarNext,
    urlImg,
    filterSpecialist,
    filterCity,
    detailSpecialist

  } = UseSpecialist()

  return (
    <div>
        <Find/>
        <CarouselSevices current={servicesTravel[7].title}/>
        <BannerSpecialist/>
        <ButtonsFilters filterSpecialist={filterSpecialist} filterCity={filterCity}/>
        <AllCardsSpecialist data={dataAlways} urlImg={urlImg}  loading={loading} detailSpecialist={detailSpecialist}/>
        <Paginado nextHandler={nextHandler} prevHandler={prevHandler} currentPage={currentPage} data={services} mostrarNext={mostrarNext}/>
    </div>
  )
}

export default Specialists